import firebase from "firebase/app";

export class SocketClient {
  constructor(socketHost, user) {
    this.socketHost = socketHost;
    this.socket = null;
    this.heartbeatInterval = null;
    this.user = user;
    this.handlers = [];
  }

  connect() {
    const socketUrl = `${this.socketHost}/${this.user.uid}`;
    // console.log("connecting to socket on", socketUrl);
    this.socket = new WebSocket(socketUrl);
    this.socket.onopen = async () => {
      // console.log("connected to socket");
      this.heartbeatInterval = setInterval(() => {
        this.socket.send("ping");
      }, 10000);
      const token = await firebase.auth().currentUser.getIdToken(true);
      this.sendMessage("authenticate", { token });
    };
    this.socket.onclose = () => {
      // console.log("socket closed");
      clearInterval(this.heartbeatInterval);
      setTimeout(() => {
        this.connect();
      }, 1000);
    };
    this.socket.onmessage = (evt) => {
      if (evt.data === "pong") {
        return;
      }
      try {
        const parsed = JSON.parse(evt.data);
        this.handlers.forEach((handler) => {
          try {
            handler(parsed);
          } catch (err) {
            console.log("error in a single socket handler", { err, handler });
          }
        });
      } catch (err) {
        console.log("error handling message", err);
      }
    };
    this.socket.onerror = (evt) => {
      console.log("socket error", evt);
    };
  }

  sendMessage(messageType, payload) {
    const serialize = JSON.stringify({ messageType, payload });
    this.socket.send(serialize);
  }

  destroy() {
    clearInterval(this.heartbeatInterval);
    // reassign onclose handler to avoid reconnecting
    this.socket.onclose = () => {
      // console.log("socket closed");
    };
    this.socket.close();
  }

  addHandler(handler) {
    this.handlers.push(handler);
    return () => {
      this.handlers = this.handlers.filter((h) => h !== handler);
    };
  }
}
